<template>
  <div id="unitArrival_page" class="unitArrival">
    <UnitArrivalInstructions
      class="unitArrival__instructions"
      @triggerConfirmArriving="toggleConfirmArrivingModalDisplay"
      @triggerNotArrivedYet="toggleConfirmArrivingModalDisplay"
    />

    <InfoTicket
      ref="infoTicket-conclusionPage"
      :hasSurvey="false"
      :unit="currentUnitName"
      :brand="this.selectedBrand.name"
      :patientName="patientName"
      :scheduleDate="scheduleDate"
      :qrcode="false"
    />

    <DrawerBottom :open="openDrawer" @toggle="openDrawer = !openDrawer" @close="openDrawer = false">
      <template #content>
        <div class="drawer-content">
          <h3>{{ !notArrived ? 'Confirmação de chegada' : 'Quase lá!' }}</h3>

          <p>Atenção! A próxima etapa só deve ser realizada ao chegar no laboratório.</p>

          <div class="drawer-buttons">
            <button v-if="!notArrived" @click="confirmedArrivalFlow">Confirmar chegada</button>
            <button @click="notArrivalYet">
              {{ notArrived ? 'Entendi' : 'Ainda não cheguei' }}
            </button>
          </div>
        </div>
      </template>
    </DrawerBottom>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { step } from '@/utils/enums/googleAnalytics';
import { admissionProcessFinishedMixin, dataLayersMixin, unitArrivalMixin } from '@/utils/mixins';
import UnitArrivalInstructions from '@/views/unitArrival/partials/UnitArrivalInstructions.vue';
import DrawerBottom from '@/components/drawerBottom.component.vue';
import InfoTicket from '../conclusion/partials/InfoTicket.partial.vue';
import moment from 'moment';

export default {
  name: 'UnitArrival',
  mixins: [admissionProcessFinishedMixin, dataLayersMixin, unitArrivalMixin],
  components: {
    UnitArrivalInstructions,
    DrawerBottom,
    InfoTicket,
  },
  data() {
    return {
      previousRoute: null,
      currentUnitName: '',
      patientName: '',
      scheduleDate: '',
    };
  },

  computed: {
    ...mapState({
      mdmData: ({ mdm }) => mdm.data,
      atUnit: ({ global }) => global.atUnit,
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
      medicalOrders: ({ currentAdmission }) => currentAdmission.data.medicalOrders,
    }),

    ...mapGetters({
      haveScheduledExams: 'haveScheduledExams',
    }),
  },

  methods: {
    async checkAdmissionProcessingCompletion() {
      this.previousRoute = this.$route.redirectedFrom;

      if (this.previousRoute !== 'checkIn') {
        await this.admissionProcessFinished();

        // eslint-disable-next-line
        dataLayer.push({
          ...step.SERVICE_COMPLETED,
          tipoAgendamento: this.haveScheduledExams.label,
        });
      }
    },

    setupUnitArrival() {
      if (this.atUnit) {
        this.confirmedArrivalFlow();
      }
    },

    async getScheduleDate() {
      let dateFormat = 'DD/MM/YYYY - kk:mm';
      if (this.currentAdmission.source.origin === 'CEV') {
        dateFormat = 'DD/MM/YYYY';
      }

      this.scheduleDate = moment(this.currentAdmission.admissionDate).format(dateFormat);
    },

    getPatientName() {
      if (this.mdmData) {
        this.patientName = this.mdmData.name;
      }
    },
    getUnit() {
      if (this.currentAdmission.source.origin !== 'CEV') {
        if (this.selectedUnit) {
          this.currentUnitName = this.selectedUnit.nome;
        }
      }
    },
  },

  async mounted() {
    this.checkAdmissionProcessingCompletion();
    await this.getScheduleDate();
    this.getUnit();
    this.getPatientName();
  },

  created() {
    this.setupUnitArrival();
    this.mostCommonPagesAnalytics({
      step: 'confirmação_chegada_unidade',
      screen: 'confirmação_chegada_unidade',
    });
  },
};
</script>

<style lang="scss">
.unit-arrival .container {
  background-color: var(--color-grey-1);
  height: 100%;
  padding: 0px;
}

.header__message {
  font-weight: var(--font-weight-light);
}

.header__title {
  font-size: var(--font-size-3);
  font-weight: 600;
}

.drawer-content {
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #161616;
    margin-bottom: 24px;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    text-align: center;
    color: var(--color-grey-11);
    margin-bottom: 24px;
  }
  .drawer-buttons {
    display: flex;
    flex-direction: column;

    button {
      border-radius: 8px;
      background-color: var(--color-primary);
      border: 1px solid var(--color-primary);
      color: white;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      padding: 12px 0;
      width: 100%;

      &:nth-child(2) {
        margin-top: 16px;
        border-color: transparent;
        background-color: transparent;
        color: var(--color-primary);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.unitArrival {
  background-color: var(--color-grey-1);
  min-height: 100%;
  padding: 16px 20px;
  width: 100%;
  overflow: hidden;
  position: relative;

  .unitArrival__instructions {
    margin-bottom: 24px;
    box-shadow:
      0 12px 12px rgba(22, 22, 22, 0.04),
      0 24px 56px rgba(22, 22, 22, 0.08);
  }

  & .modal {
    & .layout__buttons button:last-of-type {
      margin-top: 0;
    }

    & .header__message {
      font-weight: var(--font-weight-light);
    }
  }
}
</style>
